import fadeOut from './fade-out'
import timeAgo from './time-ago'
import alertConfirmation from './alert-confirmation'

export default {
  fadeOut,
  timeAgo,
  alertConfirmation
}
